module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "graph card"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css",
      "integrity": "sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N",
      "crossorigin": "anonymous"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "name": "viewport",
      "content": "width=device-width, initial-scale=1, shrink-to-fit=no"
    }
  }), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'my-kh',
        params: {
          language: _vm.$route.params.language
        }
      }
    }
  }, [_c('button', {
    staticStyle: {
      "background-color": "#fff",
      "border": "none"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/AquaWiz_trans_minimum.png"),
      "width": "110"
    }
  })])]), _vm._v(" "), (_vm.serial.startsWith('KH1')) ? _c('span', [_c('img', {
    staticStyle: {
      "width": "20px"
    },
    attrs: {
      "src": require("../assets/KHA.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.serial.startsWith('KH2')) ? _c('span', [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": require("../assets/KHApro.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.serial != _vm.devname) ? _c('span', {
    staticStyle: {
      "font-size": "1.1em",
      "color": "red"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.s_number) + " " + _vm._s(_vm.devname))])]) : _c('span', {
    staticStyle: {
      "font-size": "1.1em",
      "color": "red"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.devname))])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn-primary",
    staticStyle: {
      "font-size": "12px",
      "border-radius": "5px"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.fillData(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][0]))]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    staticStyle: {
      "font-size": "12px",
      "border-radius": "5px"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.fillData(3)
      }
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][5]))]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    staticStyle: {
      "font-size": "12px",
      "border-radius": "5px"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.fillData(7)
      }
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][1]))]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    staticStyle: {
      "font-size": "12px",
      "border-radius": "5px"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.fillData(30)
      }
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][2]))]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    staticStyle: {
      "font-size": "12px",
      "border-radius": "5px"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.fillData(365)
      }
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][3]))]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    staticStyle: {
      "font-size": "12px",
      "border-radius": "5px"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.row2csv()
      }
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][8]))])]), _vm._v(" "), (_vm.er_c >= 5) ? _c('span', {
    staticStyle: {
      "float": "right",
      "color": "red"
    }
  }, [_c('strong', [_vm._v("  #" + _vm._s(_vm.er_pump) + _vm._s(_vm.msglist[_vm.$route.params.language][9]) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.phSignal < 0) ? _c('span', {
    staticStyle: {
      "float": "right"
    }
  }) : (_vm.phSignal >= 0 && _vm.phSignal < 100) ? _c('span', {
    staticStyle: {
      "float": "right",
      "color": "red"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][6]) + " " + _vm._s(_vm.phSignal) + "%," + _vm._s(_vm.msglist[_vm.$route.params.language][7]))])]) : (_vm.phSignal >= 100 && _vm.phSignal < 1000) ? _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][6]) + "100%")])]) : _c('span', {
    staticStyle: {
      "float": "right",
      "color": "red"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][6]) + " fail," + _vm._s(_vm.msglist[_vm.$route.params.language][7]))])])], 1), _vm._v(" "), (_vm.win_width > _vm.win_height) ? _c('line-graph', {
    staticStyle: {
      "position": "relative",
      "height": "90vh",
      "width": "100%"
    },
    attrs: {
      "chart-data": _vm.datacollection,
      "options": _vm.choptions
    }
  }) : _c('line-graph', {
    staticStyle: {
      "position": "relative",
      "height": "45vh",
      "width": "100%"
    },
    attrs: {
      "chart-data": _vm.datacollection,
      "options": _vm.choptions
    }
  }), _vm._v(" "), (_vm.ph1 != -1 && _vm.win_width < _vm.win_height) ? _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 row mx-0",
    domProps: {
      "innerHTML": _vm._s(_vm.msglist[_vm.$route.params.language][10])
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c98f38c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KH_graph.vue
// module id = 506
// module chunks = 0